// npm
import React, { memo } from 'react'
import { IGatsbyImageData } from 'gatsby-plugin-image'
import loadable from '@loadable/component'

// src
import ContentSectionBgImageWrapper from './ContentSectionBgImageWrapper'
import BgImageSwiper, { slide } from '@molecules/swipers/BgImageSwiper'
import SectionText, { SectionTextProps } from '@molecules/text/SectionText'
import { Box, Container } from '@mui/material'
import {
  createImageSectionTextDefaults,
  CreateImageSectionTextDefaultProps,
} from '@helpers/createImageSectionTextDefaults'
import Accreditations from './Accreditations'

export type slideData = {
  id: string
  imageLandscape: IGatsbyImageData[]
  imagePortrait: IGatsbyImageData[]
}

export interface Props {
  id: string
  slidesData: slideData[]
  isFirstSection?: boolean
  foregorundContentData: CreateImageSectionTextDefaultProps
}

const ContentSectionSlideshowBg = ({
  id,
  slidesData,
  isFirstSection,
  foregorundContentData,
}: Props) => {
  let sectionTextProps: SectionTextProps = createImageSectionTextDefaults({
    ...foregorundContentData,
    sectionTextVariant: 'centered',
  })

  const hero = isFirstSection

  sectionTextProps.subtitleProps.color = 'white'
  // @ts-ignore
  // sectionTextProps.subtitleProps.borderType = hero ? 'bottom' : null
  sectionTextProps.subtitleProps.borderType = undefined
  // @ts-ignore
  sectionTextProps.buttonLinkProps.colorVariant = 'white-text'
  // @ts-ignore
  sectionTextProps.textBoxProps = { mt: 4, color: 'white' }
  sectionTextProps.mainHeadingProps.typographyProps.variant = 'h2'
  sectionTextProps.mainHeadingProps.typographyProps.color = 'white'

  let slides: slide[] = []
  slidesData.map((slideData: slideData) => {
    slides.push({
      id: slideData.id,
      children: (
        <ContentSectionBgImageWrapper
          imagePortrait={slideData.imagePortrait}
          imageLandscape={slideData.imageLandscape}
          isFirstSection={isFirstSection}
        />
      ),
    })
  })

  return (
    <BgImageSwiper slides={slides}>
      <Container
        maxWidth={false}
        className={hero ? 'fixed-height' : ''}
        sx={{ height: '100%', position: 'relative', mx: 0, px: 0 }}
      >
        <Box
          className={hero ? 'fixed-height' : ''}
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            width: 1,
            height: 1,
            py: 10,
            mt: 4,
          }}
        >
          <SectionText
            {...sectionTextProps}
            gridProps={{ xs: 12, md: 9, lg: 7, xl: 10 }}
          />
          <Accreditations />
        </Box>
      </Container>
    </BgImageSwiper>
  )
}

export default memo(ContentSectionSlideshowBg)
